import { render, staticRenderFns } from "./LastNews.vue?vue&type=template&id=7e1ebd1f&scoped=true"
import script from "./LastNews.vue?vue&type=script&lang=js"
export * from "./LastNews.vue?vue&type=script&lang=js"
import style0 from "./LastNews.vue?vue&type=style&index=0&id=7e1ebd1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1ebd1f",
  null
  
)

export default component.exports